import { arrayOf, number, shape } from 'prop-types'

import Review_v1 from './Review_v1'
import { ReviewsSummary_v1 } from './ReviewsSummary_v1'

const Reviews_v1 = shape({
  page: number,
  pageSize: number,
  totalItems: number,
  summary: ReviewsSummary_v1,
  allReviewsSummary: arrayOf(ReviewsSummary_v1),
  reviews: arrayOf(Review_v1),
})

export default Reviews_v1
